export enum OriginTypeEnum {
  DIRECT_UPLOAD = 'DIRECT_UPLOAD',
  DDE_PORTAL = 'DDE_PORTAL',
  COPY_PORTAL = 'COPY_PORTAL',
  CORRECTED = 'CORRECTED',
  RC = 'RC'
}
